import React, { useState, useEffect } from "react";

import { atom, useAtom } from "jotai";
// @ts-ignore
import logo from "src/assets/images/branding/wizard-logo.jpg";
import { useTranslation } from "react-i18next";
import { useLanguages } from "src/hooks/useLanguages";
import { ChevronDown, ChevronUp, Globe, User } from "lucide-react";
import i18next from "i18next";
import { useNavigate } from "react-router-dom";
import CheckoutSteps from "./CheckoutSteps";
import Sidebar from "./Sidebar";
import PaymentSuccessful from "./PaymentSuccessful";
import ClubCreationStep from "./ClubCreation";
import { SuscriptionView } from "./SubscriptionView";
import PaymentMethodStep from "./PaymentMethod";
import TripodsStep from "./TripodsStep";
import { CameraStep } from "./CameraStep";
import AccessoriesStep from "./AccessoriesStep";
import { itemsAtom } from "src/atoms/constantsCheckout";

const Checkout = () => {
    const [step, setStep] = useState(1);
    // const [items, setItems] = useState<any>(itemsAtom)
    const [items, setItems] = useAtom(itemsAtom);
    const [packages, setPackages] = useState([]);
    const { t } = useTranslation();
    const [showChangeLanguage, setShowChangeLanguage] = useState(false);
    const { options, languageChosen } = useLanguages();
    const navigate = useNavigate();

    console.log("items", items);

    console.log("languageChosen", options);
    // useEffect(() => {
    //     fetch("http://192.168.1.61/api-wizard-stripe/retrievePackages.php")
    //         .then((response) => response.json())
    //         .then((data) => {
    //             if (data.status === "ok") {
    //                 setPackages(data.result);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error("Error fetching packages:", error);
    //         });
    // }, []);

    const renderStep = () => {
        switch (step) {
            case 1:
                return (
                    <SuscriptionView step={step} setStep={setStep} packages={packages} />
                );
            case 2:
                return <CameraStep step={step} setStep={setStep} packages={packages} />;
            case 3:
                return (
                    <TripodsStep step={step} setStep={setStep} packages={packages} />
                );

            case 4:
                return (
                    <AccessoriesStep step={step} setStep={setStep} packages={packages} />
                );
            case 5:
                return <ClubCreationStep step={step} setStep={setStep} />;
            case 6:
                return <PaymentMethodStep step={step} setStep={setStep} />;
            case 7:
                return <PaymentSuccessful />;
        }
    };
    return (
        <div className="min-h-dvh bg-gray-50 flex flex-col">
            <div className="bg-white py-2 sm:py-3 flex items-center justify-between px-4 sm:px-6 border-b sticky top-0 z-30">
                <img
                    onClick={() => navigate(-1)}
                    className="h-10 w-10 rounded-lg cursor-pointer shrink-0"
                    src={logo}
                    alt="wizard-logo"
                />
                <div className="flex items-center gap-2 sm:gap-3">
                    {/* <button
                        onClick={() => window.location.href = "https://wizardfootball.com/login"}
                        className="group relative flex items-center gap-2 px-4 py-2.5 border border-gray-200 hover:border-gray-300 rounded-xl text-sm font-medium text-gray-700 hover:text-gray-900 bg-white hover:bg-gray-50 transition-all duration-200 shadow-sm hover:shadow-md"
                    >
                        <div className="w-5 h-5 rounded-full bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center group-hover:from-blue-100 group-hover:to-purple-100 transition-all duration-200">
                            <User className="w-3 h-3 text-gray-600 group-hover:text-blue-600" />
                        </div>
                        <span className="hidden sm:inline">{t("sign_in")}</span>

                        <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 transform translate-x-[-100%] group-hover:translate-x-[100%] group-hover:duration-700"></div>
                    </button> */}

                    <div className="relative ml-2 sm:ml-4">
                        <button
                            onClick={() => setShowChangeLanguage(!showChangeLanguage)}
                            className="group flex items-center gap-2 px-3 py-2.5 text-sm font-medium text-gray-600 hover:text-gray-900 rounded-xl hover:bg-gray-50 transition-all duration-200 border border-transparent hover:border-gray-200"
                        >
                            <div className="w-5 h-5 rounded-full bg-gradient-to-br from-blue-100 to-purple-100 flex items-center justify-center">
                                <Globe className="w-3 h-3 text-blue-600" />
                            </div>
                            <span className="hidden md:inline">{languageChosen}</span>
                            <div className="transition-transform duration-200">
                                {showChangeLanguage ? (
                                    <ChevronUp className="w-4 h-4" />
                                ) : (
                                    <ChevronDown className="w-4 h-4" />
                                )}
                            </div>
                        </button>

                        {showChangeLanguage && (
                            <>
                                {/* Backdrop */}
                                <div
                                    className="fixed inset-0 z-40"
                                    onClick={() => setShowChangeLanguage(false)}
                                ></div>

                                {/* Dropdown */}
                                <div className="absolute right-0 mt-2 w-48 bg-white/95 backdrop-blur-xl rounded-2xl shadow-2xl border border-gray-200/50 z-50 overflow-hidden animate-in fade-in slide-in-from-top-2 duration-200">
                                    <div className="p-2">
                                        <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide px-3 py-2">
                                            {t("choose_language")}
                                        </div>
                                        {options?.map((option, index) => (
                                            <button
                                                key={option.value}
                                                onClick={() => {
                                                    i18next.changeLanguage(option.value);
                                                    setShowChangeLanguage(false);
                                                }}
                                                className="group w-full flex items-center gap-3 px-3 py-2.5 text-sm text-left rounded-xl hover:bg-gradient-to-r hover:from-blue-50 hover:to-purple-50 transition-all duration-200"
                                                style={{ animationDelay: `${index * 50}ms` }}
                                            >
                                                <span className="text-lg">{option.flag}</span>
                                                <span className="font-medium text-gray-700 group-hover:text-gray-900">
                                                    {option.label}
                                                </span>
                                                {option.label === languageChosen && (
                                                    <div className="ml-auto w-2 h-2 bg-blue-500 rounded-full"></div>
                                                )}
                                            </button>
                                        ))}
                                    </div>

                                    {/* Subtle gradient border */}
                                    <div className="absolute inset-0 rounded-2xl bg-gradient-to-r from-blue-200/20 via-transparent to-purple-200/20 pointer-events-none"></div>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>

            <div className="flex flex-1 min-h-0 flex-col">
                {/* Steps */}
                <div className="shrink-0">
                    <CheckoutSteps items={items} step={step} setStep={setStep} />
                </div>

                {/* Main Content */}
                <div className="flex-1 min-h-0 grid grid-cols-1 lg:grid-cols-4">
                    <div className="lg:col-span-3 min-h-0 overflow-y-auto overflow-x-hidden bg-white">
                        {renderStep()}
                    </div>
                    <div className="hidden lg:block lg:col-span-1 min-h-0 overflow-y-auto border-l border-gray-200">
                        <Sidebar items={items} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Checkout;
